export const Admininventory = {
  Admininventory: 
  {
    permissionsId:'b1b1dd4b-a814-4bf2-008a-08dd03ecea2b',
    permissionsName:'Admin inventory' , 
    componentsId:null,
    components:null
  }
} ;
